/* eslint-disable max-lines */
import { css } from 'styled-components';
import { CFTokens } from '../tokens';
export const border = ({ color = 'default', radius = 'none', side = 'all', size = 'thin', style = 'solid', }) => {
    const colorValue = CFTokens.BORDER_COLOR[color.split('-').join('_').toUpperCase()];
    const sizeValue = CFTokens.BORDER_SIZE[size.toUpperCase()];
    if (style === 'dashed') {
        const radiusValue = CFTokens.BORDER_RADIUS[radius.toUpperCase()];
        const parsedColorValue = colorValue.replace('#', '');
        const backgroundImageValue = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='${radiusValue}' ry='${radiusValue}' stroke='%23${parsedColorValue}' stroke-width='${sizeValue * 2}' stroke-dasharray='4%2c12' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e")`;
        return {
            backgroundImage: backgroundImageValue,
            borderRadius: radiusValue,
        };
    }
    switch (side) {
        case 'top':
            return {
                borderTopColor: colorValue,
                borderTopStyle: 'solid',
                borderTopWidth: sizeValue,
            };
        case 'right':
            return {
                borderRightColor: colorValue,
                borderRightStyle: 'solid',
                borderRightWidth: sizeValue,
            };
        case 'bottom':
            return {
                borderBottomColor: colorValue,
                borderBottomStyle: 'solid',
                borderBottomWidth: sizeValue,
            };
        case 'left':
            return {
                borderLeftColor: colorValue,
                borderLeftStyle: 'solid',
                borderLeftWidth: sizeValue,
            };
        case 'all':
        default:
            return {
                borderColor: colorValue,
                borderStyle: 'solid',
                borderWidth: sizeValue,
            };
    }
};
export const borderAsCSS = ({ color = 'default', radius = 'none', side = 'all', size = 'thin', style = 'solid', }) => {
    const colorValue = CFTokens.BORDER_COLOR[color.split('-').join('_').toUpperCase()];
    const sizeValue = CFTokens.BORDER_SIZE[size.toUpperCase()];
    if (style === 'dashed') {
        const radiusValue = CFTokens.BORDER_RADIUS[radius.toUpperCase()];
        const parsedColorValue = colorValue.replace('#', '');
        const backgroundImageValue = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='${radiusValue}' ry='${radiusValue}' stroke='%23${parsedColorValue}' stroke-width='${sizeValue * 2}' stroke-dasharray='4%2c12' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e")`;
        return css `
      background-image: ${backgroundImageValue};
      border-radius: ${radiusValue}px;
    `;
    }
    switch (side) {
        case 'top':
            return css `
        border-top-color: ${colorValue};
        border-top-style: solid;
        border-top-width: ${sizeValue}px;
      `;
        case 'right':
            return css `
        border-right-color: ${colorValue};
        border-right-style: solid;
        border-right-width: ${sizeValue}px;
      `;
        case 'bottom':
            return css `
        border-bottom-color: ${colorValue};
        border-bottom-style: solid;
        border-bottom-width: ${sizeValue}px;
      `;
        case 'left':
            return css `
        border-left-color: ${colorValue};
        border-left-style: solid;
        border-left-width: ${sizeValue}px;
      `;
        case 'all':
        default:
            return css `
        border-color: ${colorValue};
        border-style: solid;
        border-width: ${sizeValue}px;
      `;
    }
};
